<template>
  <div class="pup-image-preview">
    <van-image-preview v-model="previewComponentshow" :images="previewimages" :startPosition="prewivewIndex"
      @close="closeImagePreview" @change="onChange">
      <template v-slot:index>
        <div class="pup-image-preview-div">{{ previewimages.length > 0 ? index + 1 : 0 }} / {{previewimages.length}}
        </div>
      </template>
    </van-image-preview>
  </div>

</template>

<script>
  export default {
    props: {
      previewshow: {
        type: Boolean,
        defaulte: false
      },
      previewimages: {
        type: Array,
        defaulte: []
      },
      prewivewIndex: {
        type: Number,
        defaulte: 0
      },
    },
    data() {
      return {
        index: 0,
        previewComponentshow: false
      }
    },
    watch: {
      previewshow: {
        handler(newval) {
          this.previewComponentshow = newval
        },
        deep: true
      }
    },
    created() {
      this.previewComponentshow = this.previewshow
    },
    methods: {
      closeImagePreview(data) {
        this.$emit('closeImagePreview', data)
      },
      onChange(index) {
        this.index = index;
      },
    }
  }
</script>

<style lang="less">
.pup-image-preview{
  .van-image-preview__index {
    bottom: 20%;
    top: auto;
    .pup-image-preview-div {
      position: absolute;
      width: 5rem;
      text-align: center;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>